var mlrSearch = angular.module('taric.mlr.search', ['taric.model.menu', 'common.helper', 'taric.model.mlr', 'common.filter.commoditycode'])
    .controller('MlrSearchController', function (CONSTANTS, MlrReportModel, $rootScope, $scope, CommonHelper, $timeout, $state, $filter, $stateParams, $translate, $location) {
        var mlrSearchCtrl = this;
        mlrSearchCtrl.init = function(){
            mlrSearchCtrl.dateFormat = CONSTANTS.dateFormat;
            mlrSearchCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            mlrSearchCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            mlrSearchCtrl.searchCriteria = MlrReportModel.getSearchCriteria();
            mlrSearchCtrl.regulationPrefixList = CONSTANTS.menu.measuresLinkedRegulation.regulationPrefixList;

            if (mlrSearchCtrl.searchCriteria.regulationPrefix &&
                mlrSearchCtrl.regulationPrefixList.indexOf(mlrSearchCtrl.searchCriteria.regulationPrefix) < 0) {
                mlrSearchCtrl.searchCriteria.regulationPrefix = null;
            }

            if (mlrSearchCtrl.isExternalLink() && mlrSearchCtrl.validateExternalParameters()) {
                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                mlrSearchCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        mlrSearchCtrl.isExternalLink = function(){
            // Verify 'frm' parameter to avoid auto-search after looking up commodity code.
            return (!$stateParams.frm || $stateParams.frm !== 'ccLookup') && $stateParams.sd && $stateParams.rp && $stateParams.rn && $stateParams.ry;
        };

        // Check whether the external parameters are valid or not
        mlrSearchCtrl.validateExternalParameters = function(){
            return mlrSearchCtrl.validateSearchForm();
        };

        mlrSearchCtrl.search = function(){
            mlrSearchCtrl.loadDataFromServer(1);
        };

        mlrSearchCtrl.validateSearchForm = function(){
            mlrSearchCtrl.resetError();
            return mlrSearchCtrl.validateSimulationDate() &&
                    mlrSearchCtrl.validateRegulationPrefix() &&
                    mlrSearchCtrl.validateRegulationNumber() &&
                    mlrSearchCtrl.validateRegulationYear() &&
                    mlrSearchCtrl.validateCommodityCodeRange();

        };

        mlrSearchCtrl.validateSimulationDate = function(){
            if (!mlrSearchCtrl.searchCriteria.simulationDate){
                mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.simulationDate";
                return false;
            }
            return true;
        };

        mlrSearchCtrl.validateRegulationPrefix = function(){
            if (CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationPrefix) === ""){
                mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.regulationPrefix";
                return false;
            }
            return true;
        };

        mlrSearchCtrl.validateRegulationNumber = function(){
            if (CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationNumber) === ""){
                mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.regulationNumber";
                return false;
            } else {
                mlrSearchCtrl.errorCode = CommonHelper.validateStringByPattern(
                    mlrSearchCtrl.searchCriteria.regulationNumber,
                    "^[0-9]{4}$",
                    "i8n.qry.mlr.search.validation.invalid.regulationNumber");
            }
            return mlrSearchCtrl.errorCode === null;
        };

        mlrSearchCtrl.validateRegulationYear = function(){
            if (CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationYear) === ""){
                mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.missing.regulationYear";
                return false;
            } else {
                mlrSearchCtrl.errorCode = CommonHelper.validateStringByPattern(
                    mlrSearchCtrl.searchCriteria.regulationYear,
                    "^[0-9]{2}$",
                    "i8n.qry.mlr.search.validation.invalid.regulationYear");
            }
            return mlrSearchCtrl.errorCode === null;
        };

        mlrSearchCtrl.validateCommodityCodeRange = function(){
            var commodityCodeFrom = CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeFrom);
            var commodityCodeTo = CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeTo);
            if (commodityCodeFrom !== "" && (commodityCodeFrom.length % 2 !== 0 || commodityCodeFrom.length > 10)){
                mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeStart";
                return false;
            }
            if (commodityCodeTo !== "" && (commodityCodeTo.length % 2 !== 0 || commodityCodeFrom.length > 10)){
                mlrSearchCtrl.errorCode = "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeEnd";
                return false;
            }
            var errorCode = CommonHelper.validateStringByPattern(
                commodityCodeFrom,
                "^[0-9 ]*$",
                "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeStart");
            if (errorCode !== null) {
                mlrSearchCtrl.errorCode = errorCode;
                return false;
            }
            errorCode = CommonHelper.validateStringByPattern(
                commodityCodeTo,
                "^[0-9 ]*$",
                "i8n.qry.mlr.search.validation.invalid.commodityCodeRangeEnd");
            if (errorCode !== null) {
                mlrSearchCtrl.errorCode = errorCode;
                return false;
            }
            return true;
        };

        mlrSearchCtrl.resetError = function(){
            mlrSearchCtrl.handleError();
        };

        mlrSearchCtrl.handleError = function(error){
            if (!error){
                mlrSearchCtrl.errorCode = null;
                mlrSearchCtrl.errorParams = null;
            } else {
                mlrSearchCtrl.errorCode = error.data.code;
                mlrSearchCtrl.errorParams = error.data.params;
                mlrSearchCtrl.formatDateParameters(mlrSearchCtrl.errorParams);
            }
        };

        mlrSearchCtrl.openDatePicker = function(){
            mlrSearchCtrl.isDatePickerOpen = true;
        };

        mlrSearchCtrl.resetSearchResult = function(){
            mlrSearchCtrl.searchResult = null;
        };

        mlrSearchCtrl.searchResultPageChanged = function(page){
            mlrSearchCtrl.loadDataFromServer(page);
        };

        mlrSearchCtrl.selectCommodityCode = function (commodityCode, date, type, ccField) {

            $state.go('taric.nomenclature.sbn', {
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(date),
                d: 'I',
                frm: 'taric.report.mlr',
                type: type,
                ccField: ccField
            });
        };

        mlrSearchCtrl.selectCommodityCodeFrom = function(commodityCode){
            mlrSearchCtrl.selectCommodityCode(commodityCode, mlrSearchCtrl.searchCriteria.simulationDate, "lookup", "commodityCodeFrom");
        };

        mlrSearchCtrl.selectCommodityCodeTo = function(commodityCode){
            mlrSearchCtrl.selectCommodityCode(commodityCode, mlrSearchCtrl.searchCriteria.simulationDate, "lookup", "commodityCodeTo");
        };

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            mlrSearchCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                mlrSearchCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });

        mlrSearchCtrl.loadDataFromServer = function(page){
            if(!mlrSearchCtrl.validateSearchForm()){
                return;
            }

            mlrSearchCtrl.loadDataFromServerWithoutValidation(page);
        };

        mlrSearchCtrl.loadDataFromServerWithoutValidation = function(page){

            // Reset search result before searching
            mlrSearchCtrl.resetSearchResult();
            mlrSearchCtrl.searching = true;
            MlrReportModel.searchMeasures(page).then(function(searchResult) {
                mlrSearchCtrl.searchResult = searchResult;
                mlrSearchCtrl.searching = false;
                mlrSearchCtrl.searchResult.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(mlrSearchCtrl.searchCriteria.simulationDate);
                if (mlrSearchCtrl.searchResult.infoCode &&
                    "i8n.common.pastDate" === mlrSearchCtrl.searchResult.infoCode) {
                    mlrSearchCtrl.searchResult.infoParams = CONSTANTS.pastDate;
                }
                mlrSearchCtrl.updateBrowserURL();
            }, function(error){
                mlrSearchCtrl.searching = false;
                mlrSearchCtrl.handleError(error);
            });
        };

        /**
         * Measures linked to a regulation
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/mlr?sd={SimulationDate}&rp={RegulationPrefix}&rn={RegulationNumber}&ry={RegulationYear}&ccs={CommodityCodeStart}&cct={CommodityCodeEnd}&l={Language}
         *
         * Example:
         * http://localhost:8080/arctictariff-public-web/#!/taric/report/reliefcode/search?sd=2015-01-01&rp=R&rn=1006&ry=11&ccs=010121&cce=010229&l=en
         */
        mlrSearchCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            // Do not keep additional parameters because there is no return to caller page
            $location.search({
                sd: CommonHelper.getBookmarkDateString(mlrSearchCtrl.searchCriteria.simulationDate),
                rp: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationPrefix),
                rn: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationNumber),
                ry: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.regulationYear),
                ccs: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeFrom),
                cce: CommonHelper.removeSpaceCharacters(mlrSearchCtrl.searchCriteria.commodityCodeTo),
                l : $translate.use()
            }).replace();
        };

        mlrSearchCtrl.formatDateParameters = function(errorParams){
            if (errorParams) {
                var testParam = null;
                for (let param in errorParams) {
                    if (errorParams.hasOwnProperty(param)) {
                        testParam = CommonHelper.parseInputDate(errorParams[param]);
                        if (testParam){
                            errorParams[param] = $filter('date')(testParam, mlrSearchCtrl.dateFormat);
                        }
                    }
                }
            }
        };

        mlrSearchCtrl.onDateChange = function (dateString) {
            mlrSearchCtrl.resetError();
            mlrSearchCtrl.searchCriteria.simulationDate = CommonHelper.formatDate(mlrSearchCtrl.searchCriteria.simulationDate, dateString);
        };

        //export excel
        mlrSearchCtrl.exportExcel = function() {
            if (!mlrSearchCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningExport');
            MlrReportModel.searchMeasures().then(function(searchResult) {

                var reportDate = $filter('date')(new Date(), CONSTANTS.dateTimeFormat);
                mlrSearchCtrl.allSearchResult = searchResult;
                document.getElementById('reportDateExtr').innerHTML = reportDate;

                setTimeout(function(){
                    var title = $filter('translate')('i8n.common.menu.query.data.measuresLinkedToRegulation');
                    var ws = {
                        '!cols': [{
                            wpx: 200
                        }, {
                            wpx: 130
                        }, {
                            wpx: 130
                        }, {
                           wpx: 130
                        }, {
                            wpx: 130
                        }, {
                            wpx: 130
                        }]
                    };

                    CommonHelper.printExcel("exportExcelTable", title, ws).then(() => {
                        $rootScope.$broadcast('stopSpinningExport');
                    }, () => {
                        $rootScope.$broadcast('stopSpinningExport');
                    });

                }, 1000);

            }, function(error){
                // show errors here
                $rootScope.$broadcast('stopSpinningPrint');
            });
        };

        // export pdf
        mlrSearchCtrl.print = function(options){
            if (!mlrSearchCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningPrint');
            MlrReportModel.searchMeasures().then(function(searchResult) {
                mlrSearchCtrl.allSearchResult = searchResult;
                setTimeout(function(){

                    // print the first table of the report
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportRegulationInformation'), options);

                    // print second table of the report.
                    doc.push ({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        validDate: $filter('date')(mlrSearchCtrl.searchCriteria.simulationDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.mlr.search.resultHeader.resultTitle.label', { param0: searchResult.regulationHead.id })
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });

                }, 1000);

            }, function(error){

                // show errors here
                $rootScope.$broadcast('stopSpinningPrint');
                mlrSearchCtrl.handleError(error);
            });
        };

        $scope.$on('exportDocument', function(event, data) {
            mlrSearchCtrl.exportExcel();
        });

        $scope.$on('printDocument', function(event, data) {
            CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, mlrSearchCtrl.print, true);
        });

    });


// WEBPACK FOOTER //
// ./app/taric/report/mlr/mlr-search.js